import { PaginaDocument, PagineCatchAllDocument } from '@gql/graphql'
import { initializeApollo } from '@gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import PagebuilderTemplate from '@components/templates/PagebuilderTemplate/PagebuilderTemplate'
import useTransRoute from '@hooks/useTransRoute'

const Pagina = ({ pagina }) => {
  return <PagebuilderTemplate pagina={pagina} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  const tRoute = useTransRoute(true)

  for (const locale of locales) {
    if (locale === 'default') continue

    const client = initializeApollo(locale)

    const {
      data: { pagine },
    } = await client.query({
      query: PagineCatchAllDocument,
    })

    const excludedPaths = [
      ...new Set([
        tRoute('/azienda', locale, false)?.href,
        tRoute('/sostenibilita', locale, false)?.href,
        tRoute('/taxes', locale, false)?.href,
      ]),
    ]
    pagine.edges.forEach((x) => {
      const slugArray = x.node.path.split('/').slice(1)

      if (slugArray.length === 0 || slugArray.some((s) => !s || s.trim() === '')) {
        return
      }

      if (!excludedPaths.some((path) => x.node.path.startsWith(path))) {
        paths.push({
          params: { slug: slugArray },
          locale: locale,
        })
      }
    })
  }

  return {
    paths,
    fallback: 'blocking',
  }
}, '/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, locale, preview, previewData }, store) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const route = '/' + slug.join('/')

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        chiave: '',
        path: route,
        preview: preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina,
        key: pagina.pk,
      },
      revalidate: 60 * 20,
    }
  },
  '/[slug]'
)

export default Pagina
